import { defineMessages } from 'react-intl'

export default defineMessages({
  title: {
    id: 'SpacePublisherPage.LandingStep.Message',
    defaultMessage:
      'Keep employees in-the-know with smart notifications. Notifications will display alongside messages and content from other systems that they are integrated with.'
  },
  description: {
    id: 'SpacePublisherPage.LandingStep.SendPanel.Message',
    defaultMessage:
      "Build your notification with the easy-to-use wizard, we'll walk you through the process. Soon you'll be an expert."
  },
  engage: {
    id: 'SpacePublisherPage.LandingStep.Header',
    defaultMessage: 'Engage with Employees'
  },
  header: {
    id: 'SpacePublisherPage.LandingStep.SendPanel.Header',
    defaultMessage: 'Send Notifications'
  },
  introduction: {
    id: 'SpacePublisherPage.LandingStep.DocsPanel.Link.Intro',
    defaultMessage: 'Introduction to notifications'
  },
  new: {
    id: 'SpacePublisherPage.LandingStep.DocsPanel.Header',
    defaultMessage: 'New to Notifications?'
  },
  sendButton: {
    id: 'SpacePublisherPage.LandingStep.Send',
    defaultMessage: 'Build Your Notification'
  },
  docPanelMessage: {
    id: 'SpacePublisherPage.LandingStep.DocsPanel.Message',
    defaultMessage:
      'Read through our helpful documentation to learn how to become a "notification ninja" for your workplace.'
  },
  manageSources: {
    id: 'SpacePublisherPage.LandingStep.ManageSources',
    defaultMessage: 'Manage Sources'
  }
})
